<template>
  <div class="card vue-avatar-cropper-demo text-center" id="avt">
    <!-- <img
      v-if="image_url != null || uploaded == true"
      :src="image_url"
      class="card-img avatar pick-avatar"
    />-->
    <vs-avatar
      v-if="image_url"
      class="border-2 border-solid border-grey con-vs-avatar m-0 text-6xl pick-avatar"
      size="160px"
      :color="user.color_code"
      :src="image_url"
    ></vs-avatar>
    <vs-avatar
      v-else
      class="border-2 border-solid border-grey con-vs-avatar m-0 text-6xl pick-avatar"
      size="160px"
      :text="StringHelper.changeFormatAvatar(user.name)"
      :color="user.color_code"
    ></vs-avatar>
    <!-- <h5 class="card-title mb-0">{{ user.nickname }}</h5>
    <div class="text-muted">{{ user.username }}</div>-->
    <!-- <div class="card-footer text-muted" v-html="message"></div> -->
    <!-- <div class="rounded-item" style="width: 200px; height: 10px; position: relative; background: #f99">
      <div class="rounded-item" style="position: absolute; top: 0; left: 0; height: 100%; background: #f00; transition: 0.2s ease; width: 0" :style="{width: my_width}"></div>
    </div>-->
    <div class="flex justify-center" style="height: 30px;">
      <div style="transform: translateY(-40px);" v-if="message == 'uploading'">
        <img src="../../assets/images/loading.svg" />
      </div>
      <div v-else-if="message == 'completed'" class="flex align-center text-success">
        <feather-icon icon="CheckIcon" svgClasses="h-6 w-6 stroke-current text-success mr-2" />Upload success
      </div>
    </div>
    <avatar-cropper
      @uploading="handleUploading"
      @completed="handleCompleted"
      :upload-headers="headers"
      trigger=".pick-avatar"
      :labels="labels"
      :output-options="{width: 160, height: 160}"
      :upload-url="domain + `/v1/${isFromService ? 'pos/service' : 'gocheckin/staff'}/form/upload`"
      @changed="handleChange"
    />
    <!-- <avatar-cropper
      @uploading="handleUploading"
      @completed="handleCompleted"
      :upload-headers="headers"
      trigger=".pick-avatar-1"
      :labels="labels"
      :output-options="{width: 160, height: 160}"
      :upload-url="domain + '/v1/gocheckin/staff/form/upload'"
    /> -->
    <div class="flex justify-center">
      <!-- <vs-button type="border" class="btn-upload pick-avatar" id="pick-avatar">
          <feather-icon icon="PlusIcon" svgClasses="h-4 w-4 stroke-current" />
      </vs-button>
      <vs-button type="border" color="danger" class="btn-upload">
          <feather-icon icon="TrashIcon" svgClasses="h-4 w-4 stroke-current" />
      </vs-button>-->
      <div class="add-btn-container">
        <avatar-cropper
          @uploading="handleUploading"
          @completed="handleCompleted"
          :upload-headers="headers"
          trigger=".pick-avatar-1"
          :labels="labels"
          :output-options="{width: 160, height: 160}"
          :upload-url="domain + `/v1/${isFromService ? 'pos/service' : 'gocheckin/staff'}/form/upload`"
          @changed="handleChange"
        />
        <vs-button type="border" color="primary" class="mx-2 mt-1 pick-avatar-1">
          <span v-if="image_url">Change picture</span>
          <span v-else>Add picture</span>
        </vs-button>
      </div>
      <vs-button
        type="border"
        color="danger"
        class="mx-3 mt-1"
        @click="confirmDeleteAvatar"
        v-if="image_url"
      >
        <!-- <feather-icon icon="TrashIcon" svgClasses="h-4 w-4 stroke-current" />  -->
        Delete picture
      </vs-button>
    </div>
  </div>
</template>

<script>
import AvatarCropper from "vue-avatar-cropper";
import { StringHelper } from "../../models/string_helper";
import { domain } from "../../axios";

export default {
  components: { AvatarCropper },
  name: "avatar-uploader",
  props: {
    user: {
      type: Object
      // required: true
    },
    isFromService: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.message = "ready";
  },
  data() {
    return {
      message: "ready",
      labels: { submit: "Submit", cancel: "Cancel" },
      StringHelper,
      uploaded: false,
      image_url:
        this.user && this.user.image_url != "deleted"
          ? this.user.image_url
          : null,
      domain: domain
    };
  },
  methods: {
    // eslint-disable-next-line
    handleUploading(form, xhr) {
      this.message = "uploading";
    },
    // handleUploaded(response) {
    //   if (response.status == "success") {
    //     this.user.avatar = response.url;
    //     // Maybe you need call vuex action to
    //     // update user avatar, for example:
    //     // this.$dispatch('updateUser', {avatar: response.url})
    //     this.message = "user avatar updated.";
    //   }
    // },
    // eslint-disable-next-line
    handleCompleted(response, form, xhr) {
      this.message = "completed";
      this.uploaded = true;
      this.image_url = response[0].url;
      this.$emit("uploaded-done", {
        image_url: this.image_url,
        delete_image_url: response[0].delete_url,
        image_path: response[0].path,
        image_base_url: response[0].base_url
      });
    },
    handleChange(file, reader){
      if(file.size > 2097152) { // 2MB
        this.$vs.dialog({
          type:'confirm',
          color: 'danger',
          title: 'Confirm',
          text: "Avatar size must be less than 2MB",
          acceptText: "OK",
          accept: this.handleCancelUpload,
          cancel: this.handleCancelUpload,
        });
      }
    },
    handleCancelUpload(){
      document.querySelector(".avatar-cropper-footer .avatar-cropper-btn").click();
    },
    // handlerError(message, type, xhr) {
    //   // console.log(message);
    //   // this.message = "Oops! Something went wrong...";
    // },
    confirmDeleteAvatar() {
      this.$vs.dialog({
        type: "confirm",
        title: "Confirmation",
        text: "Are you sure to delete this user avatar?",
        accept: this.deleteAvatar
      });
    },
    deleteAvatar() {
      this.message = "deleted";
      this.image_url = null;
      this.uploaded = false;
      this.$vs.notify({
        title: "Success",
        text: "Delete avatar success!",
        color: "success",
        position: "top-right"
      });
      this.$emit("uploaded-done", {
        image_url: "deleted",
        delete_image_url: "deleted",
        image_path: null,
        image_base_url: null
      });
    }
  },
  computed: {
    headers() {
      return {
        Authorization: "Bearer " + localStorage.getItem("accessToken"),
        "G-ClientID": localStorage.getItem('domainId')
      };
    }
  }
};
</script>

<style lang="scss">
#avt {
  .vue-avatar-cropper-demo {
    max-width: 18em;
    margin: 0 auto;

    .vs-button {
      width: unset !important;
    }
  }
  .avatar {
    width: 160px;
    border-radius: 50%;
    display: block;
    margin: 10px auto;
  }
  .card-img-overlay {
    display: none;
    transition: all 0.5s;
  }
  .card-img-overlay {
    display: block;
  }
  .cropper-crop-box,
  .cropper-view-box {
    border-radius: 50%;
  }
  .cropper-view-box {
    box-shadow: 0 0 0 1px #39f;
    outline: 0;
  }
  .cropper-face {
    background-color: inherit !important;
  }

  .cropper-dashed,
  .cropper-line {
    display: none !important;
  }
  .cropper-view-box {
    outline: inherit !important;
  }

  .cropper-point.point-se {
    top: calc(85% + 1px);
    right: 14%;
  }
  .cropper-point.point-sw {
    top: calc(85% + 1px);
    left: 14%;
  }
  .cropper-point.point-nw {
    top: calc(15% - 5px);
    left: 14%;
  }
  .cropper-point.point-ne {
    top: calc(15% - 5px);
    right: 14%;
  }

  .btn-upload {
    padding: 8px 10px 5px !important;
  }

  #loading-custom {
    box-sizing: border-box;
    width: 150px;
    height: 10px;
    background-image: linear-gradient(
      90deg,
      #03a9f4,
      #f441a5,
      #ffeb3b,
      #03a9f4
    ) !important;
    background-size: 400%;
    animation: animate_loading_custom 8s linear infinite;
    // &:hover {
    //   animation: animate 8s linear infinite;
    // }
  }

  @keyframes animate_loading_custom {
    0% {
      background-position: 0%;
    }

    100% {
      background-position: 400%;
    }
  }
}
</style>
